import { Box, type BoxProps, Skeleton } from "@mui/material";

interface IDataGridLoadingProps extends BoxProps {
  isLoading: boolean;
}
export const DataGridLoading = (props: IDataGridLoadingProps) => {
  const { isLoading, children, ...rest } = props;
  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
        }}
        {...rest}
      >
        <Skeleton animation="wave" width="30%" />
        <Skeleton animation="wave" width="50%" />
        <Skeleton animation="wave" width="70%" />
      </Box>
    );
  }
  return <>{children}</>;
};
